import { computed } from "vue";
import { useI18n } from "vue-i18n";

const MIN_LENGTH = 8;
const isDevBypass = import.meta.env.DEV;

export function usePasswordValidation() {
    const { t } = useI18n();

    const passwordHint = computed(() => t("predictor.dialog.password.hint"));

    function validatePassword(password: string): string | null {
        if (isDevBypass) return null;
        if (password.length < MIN_LENGTH) {
            return t("predictor.errors.insecurePassword");
        }
        return null;
    }

    function isPasswordValid(password: string): boolean {
        return validatePassword(password) === null;
    }

    return {
        passwordHint,
        validatePassword,
        isPasswordValid,
    };
}
